module.exports = __webpack_public_path__ + "img/profile_logout_icon.3b1a2a9f.svg";